export default __webpack_public_path__ + "static/6-3e7bfea2c8e90d7ea9df2786a67ffb5d.png";